import { Header, Landing, Scanning, Verdict, Footer } from '../../components';

// Assemble la page en fonction de l'etape du parcours (landing -> scanning -> verdict).
export const BaseApp = ({ step }) => (
  <div className="app-shell">
    <Header />
    <main className="app-main">
      {step === 'scanning' && <Scanning />}
      {step === 'verdict' && <Verdict />}
      {(step === 'landing' || !step) && <Landing />}
    </main>
    <Footer />
  </div>
);

export default BaseApp;
